import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=07b28c78&scoped=true&"
import script from "./ChatInput.vue?vue&type=script&lang=js&"
export * from "./ChatInput.vue?vue&type=script&lang=js&"
import style0 from "./ChatInput.vue?vue&type=style&index=0&id=07b28c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b28c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b28c78')) {
      api.createRecord('07b28c78', component.options)
    } else {
      api.reload('07b28c78', component.options)
    }
    module.hot.accept("./ChatInput.vue?vue&type=template&id=07b28c78&scoped=true&", function () {
      api.rerender('07b28c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ChatInput.vue"
export default component.exports